export const DIRECTION = {
  up: 'up',
  right: 'right',
  down: 'down',
  left: 'left',
} as const

export const LEVELS_PER_STAGE = 8

export const LOCAL_STORAGE_VERSION = '1.0.0'
export const LOCAL_STORAGE_ITEM_NAME = 'puzzleSlimeData'
